/* global User, _, jQuery */

const SUPERPROPS_KEY = 'mixpanel_superproperties'
const SUPERPROPS_UPDATED_KEY = 'mixpanel_superproperties_updated'

export const readSuperproperties = () => {
  try {
    const raw = window.localStorage.getItem(SUPERPROPS_KEY)
    return raw ? JSON.parse(raw) : undefined
  } catch {
    return undefined
  }
}

const writeSuperproperties = (data) => {
  try {
    window.localStorage.setItem(SUPERPROPS_KEY, JSON.stringify(data))
  } catch { /* noop */ }
}

const readUpdatedAt = () => {
  try {
    const raw = window.localStorage.getItem(SUPERPROPS_UPDATED_KEY)
    return raw ? Number(raw) : undefined
  } catch {
    return undefined
  }
}

const writeUpdatedAt = (timestamp) => {
  try {
    window.localStorage.setItem(SUPERPROPS_UPDATED_KEY, String(timestamp))
  } catch { /* noop */ }
}

const pipelineMixpanel = {
  isReady: false,
  readyFunctions: [],
  syncSuperproperties: function () {
    if (window.User && !User.isControlledBySu) {
      if (pipelineMixpanel._shouldUpdate()) {
        jQuery.getJSON('/api/internal/mixpanel/user_properties.json', pipelineMixpanel._updateSuperproperties)
      } else {
        pipelineMixpanel.ready()
      }
    }
  },
  whenReady: function (fn) {
    this.readyFunctions.push(fn)
  },
  ready: function () {
    this._setMixpanelUser(readSuperproperties())
    this.isReady = true
    _.each(this.readyFunctions, function (fn) { fn() })
  },
  _updateSuperproperties: function (data) {
    writeSuperproperties(data)
    pipelineMixpanel._touchLastUpdated()
    pipelineMixpanel.ready()
  },
  _setMixpanelUser: function (data) {
    window.mixpanel.people.set(data)
  },
  _shouldUpdate: function () {
    if (_.isUndefined(this._lastUpdated())) { return true }
    if (this._isOverAnHour(Date.now() - this._lastUpdated())) { return true }
    return false
  },
  _isOverAnHour: function (dateDiff) {
    return (Math.floor(dateDiff / 1000 / 60 / 60) > 1)
  },
  _lastUpdated: function () {
    return readUpdatedAt()
  },
  _touchLastUpdated: function () {
    writeUpdatedAt(Date.now())
  }
}

window.pipelineMixpanel = pipelineMixpanel
export default pipelineMixpanel
